import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
const store = new Vuex.Store({}) // 这里你可能已经有其他 module

store.registerModule('status', { // 名字自己定义

  state: {
    DACard: '',
    mobile: '', // 统一认证平台登录后赋值手机号


     LoginUrl: 'http://weixin.njrsrc.cn/', //统一认证平台url(正式)
    // LoginUrl: 'http://180.101.236.110/', //(测试)
    // LoginUrl: 'http://localhost:80/', //(测试)

    //数据接口 正式服务器
    JBUrl: 'http://weixin.njrsrc.cn/talent/jinbao',
    YBUrl: 'http://weixin.njrsrc.cn/talent/yinbao',
    TBUrl: "http://weixin.njrsrc.cn/talent/tongbao",

    //数据接口 测试服务器
    // JBUrl: 'http://180.101.236.110/talent/jinbao',
    // YBUrl: 'http://180.101.236.110/talent/yinbao',
    // TBUrl: "http://180.101.236.110/talent/tongbao",
    //内网环境下
    // JBUrl: 'http://localhost:8081/talent/jinbao',
    // YBUrl: 'http://localhost:8081/talent/yinbao',
    // TBUrl: "http://localhost:8081/talent/tongbao",

    //交通银行支付
    YHUrl: 'http://weixin.njrsrc.cn',


    TBUrlDownload: 'http://180.101.236.110:8081/',
    jftype: [], //招聘会类型ACB33C
    isLogin: false, //判断是否登陆，是否有用户基本信息personcode
    userInfo: '', //用户基本信息
    companyInfo: '', //企业基本信息
    comid: '', //单位编号
    dyid: '', //党员转入编号
    signin: false, //企业账号签到
    memberLogin: false, //党员功能开通


    YZMUrl: 'http://weixin.njrsrc.cn/file/yzmImg', //验证码
    downloadImgs: 'http://weixin.njrsrc.cn/file/downloadImgs', //图片下载-批量下载
    downloadImgsTB: 'http://172.16.44.98:8080/file/downloadImgsTongBao', //创业大赛下载
    upload: 'http://weixin.njrsrc.cn/file/upload/',
    uplaodUrl: 'http://weixin.njrsrc.cn/file/upload/jinbao/njrclwhy', //党员管理图片上传

    kzt: sessionStorage.getItem('kzt') ? sessionStorage.getItem('kzt') : '', // 档案当前状态
    checkId: '',
    wxId: sessionStorage.getItem('wxId') ? sessionStorage.getItem('wxId') : '',
    openid: '',
    isLoading: false,
    isTitle: '请稍后',
    tel: '', //手机
    PeopCenter: null, //个人中心-所有简历信息
    GzWork: null, //个人中心-工作经验
    Jybg: null, //个人中心-教育背景
    Xmjl: [], //个人中心-项目经理
    addPeopId: '', //判断是否有
    jypxItem: '',
    dxsItem: [],
    // AAC001:'',
    // AAC001: sessionStorage.getItem('info') ? JSON.parse(sessionStorage.getItem('info'))[0].AAC001 : '',
    dxsTitle: '1',
    dacd: [], //档案存档标识
    cid: '', //档案存档标识
    daJypx: [], //档案存档标识
    dagzjl: [], //档案存档标识m
    daJypxTitle: '1', //档案存档标识
    JYUrl: 'http://192.168.1.101:8081/CMP/baseServer',
    ZPHUrl: 'http://218.94.85.7:8087/BYSJY/BaseServer',
    DaUrl: 'http://218.94.85.7:8086/DA/BaseServer',
    GrUrl: 'http://192.168.19.15:8887/TS/BaseServer', //个人信息
    codeId: null, //档案管理-验证码id
    codeImg: null, //档案管理-验证码图片
    gzxz: '',
    jljbxx: [], // 简历基本信息
    "jobAddress": "",
    qwxz: '',
    gzWork: [],
    hylb: '',
    hylb1: '',
    btTitile: '',
    //工作年限 ACC217-东软
    yearList: [],
    //学历 ATC011-东软
    majorList: [{
      value: 11,
      text: "博士研究生",
    },
      {
        value: 14,
        text: "硕士研究生",
      },
      {
        value: 21,
        text: "大学本科",
      },
      {
        value: 31,
        text: "大学专科",
      },
      {
        value: 41,
        text: "中等专科",
      },
      {
        value: 44,
        text: "职业高中",
      },
      {
        value: 47,
        text: "技工学校",
      },
      {
        value: 61,
        text: "普通高中",
      },
      {
        value: 71,
        text: "初中",
      },
      {
        value: 81,
        text: "小学",
      },
      {
        value: 90,
        text: "其他",
      },
    ],
    //党员转出原因 ADYZC1-东软
    reasonList: [{
      valueName: "1",
      valueLabel: "工作调动",
      valueOrder: 1,
      codeName: "ADYZC1",
      codeLabel: "流动党员转出原因"
    },
      {
        valueName: "2",
        valueLabel: "退休",
        valueOrder: 2,
        codeName: "ADYZC1",
        codeLabel: "流动党员转出原因"
      },
      {
        valueName: "3",
        valueLabel: "其他",
        valueOrder: 3,
        codeName: "ADYZC1",
        codeLabel: "流动党员转出原因"
      }
    ],
    age: [{
      text: '不限',
      value: '99999'
    }, {
      text: '18-25岁',
      value: '1825'
    }, {
      text: '26-35岁',
      value: '2635'
    }, {
      text: '36-50岁',
      value: '3550'
    }, {
      text: '50岁以上',
      value: '51'
    }],
    years: [{
      text: '在读生',
      value: '00'
    },
      {
        text: '应届毕业生',
        value: '01'
      },
      {
        text: '一年以上',
        value: '02'
      },
      {
        text: '二年以上',
        value: '03'
      },
      {
        text: '三年以上',
        value: '04'
      },
      {
        text: '四年以上',
        value: '05'
      }, {
        text: '五年以上',
        value: '06'
      },
      {
        text: '六年以上',
        value: '07'
      }, {
        text: '七年以上',
        value: '08'
      },
      {
        text: '八年以上',
        value: '09'
      }, {
        text: '九年以上',
        value: '10'
      },
      {
        text: '十年以上',
        value: '11'
      }, {
        text: '十五年以上',
        value: '15'
      }, {
        text: '二十年以上',
        value: '20'
      },
      {
        text: '二十五年以上',
        value: '25'
      }, {
        text: '三十年以上',
        value: '30'
      }
    ],
    Major: [{
      text: '不限',
      value: ''
    }, {
      text: '信息与电子科学类',
      value: '071200'
    }, {
      text: '材料科学类',
      value: '071300'
    }, {
      text: '环境科学类',
      value: '071400'
    }, {
      text: '心理学类',
      value: '071500'
    }, {
      text: '科技信息与管理类',
      value: '071600'
    }, {
      text: '工学',
      value: '080000'
    }, {
      text: '地矿类',
      value: '080100'
    }, {
      text: '材料类',
      value: '080200'
    }, {
      text: '机械类',
      value: '080300'
    }, {
      text: '仪器仪表类',
      value: '080400'
    }, {
      text: '热能核能类',
      value: '080500'
    }],
    //文化程度"AAC011"
    Education: [{
      text: '博士研究生',
      value: 11
    }, {
      text: '硕士研究生',
      value: 14
    }, {
      text: '大学本科',
      value: 21
    }, {
      text: '大学专科',
      value: 31
    }, {
      text: '中等专科',
      value: 41
    }, {
      text: '职业高中',
      value: 44
    }, {
      text: '技工学校',
      value: 47
    }, {
      text: '普通高中',
      value: 61
    }, {
      text: '初中',
      value: 71
    }, {
      text: '小学',
      value: 81
    }, {
      text: '其他',
      value: 90
    }, {
      text: '大学双专科',
      value: 32
    }],
    TBEducation: [{ //TB学历代码
      text: '博士研究生',
      value: 11
    }, {
      text: '硕士研究生',
      value: 14
    }, {
      text: '大学本科',
      value: 21
    }, {
      text: '大学专科',
      value: 31
    }, {
      text: '中等专科',
      value: 41
    }, {
      text: '职业高中',
      value: 44
    }, {
      text: '技工学校',
      value: 47
    }, {
      text: '普通高中',
      value: 61
    }, {
      text: '初中',
      value: 71
    }, {
      text: '小学',
      value: 81
    },
      {
        text: '学龄前',
        value: 89
      }, {
        text: '其他',
        value: 90
      }, {
        text: '文盲',
        value: 99
      }, {
        text: '高级技校',
        value: 51
      }, {
        text: '技师学院',
        value: 52
      }
    ],
    TBEdu: [{ //tongbao学位代码
      text: '其他或无',
      value: 9
    }, { //tongbao学历代码
      text: '博士及以上学位',
      value: 1
    }, { //tongbao学历代码
      text: '硕士学位',
      value: 2
    }, { //tongbao学历代码
      text: '双学士学位',
      value: 3
    }, { //tongbao学历代码
      text: '学士学位',
      value: 4
    }],
    ZC: [{
      text: "无",
      value: 0
    }, {
      text: "初级",
      value: 1
    }, {
      text: "中级",
      value: 2
    }, {
      text: "高级",
      value: 3
    }],
    environment: [{
      text: "室内",
      value: 1
    },
      {
        text: "室外",
        value: 2
      },
      {
        text: "其他",
        value: 3
      }
    ],
    ZYZGDJ: [{
      text: "无要求",
      value: 0
    },
      {
        text: "职业资格一级(高级技师)",
        value: 1
      },
      {
        text: "职业资格二级(技师)",
        value: 2
      },
      {
        text: "职业资格三级(高级)",
        value: 3
      },
      {
        text: "职业资格四级(中级)",
        value: 4
      },
      {
        text: "职业资格五级(初级)",
        value: 5
      }
    ],
    title: [{
      text: "无要求",
      value: 0
    },
      {
        text: "正高级专业技术职务",
        value: 1
      },
      {
        text: "副高级专业技术职务",
        value: 2
      },
      {
        text: "中级专业技术职务",
        value: 3
      },
      {
        text: "初级专业技术职务",
        value: 4
      },
      {
        text: "职改前工程师",
        value: 5
      }
    ],
    ZZMM: [{
      text: "中共党员",
      value: '01'
    },
      {
        text: "中共预备党员",
        value: '02'
      },
      {
        text: "共青团员",
        value: '03'
      },

      {
        text: "民革会员",
        value: '04'
      },
      {
        text: "民盟盟员",
        value: '05'
      },
      {
        text: "民建会员",
        value: '06'
      },
      {
        text: "民进会员",
        value: '07'
      },
      {
        text: "农工党党员",
        value: '08'
      },
      {
        text: "致公党党员",
        value: '09'
      },

      {
        text: "九三学社社员",
        value: '10'
      },
      {
        text: "台盟盟员",
        value: '11'
      },
      {
        text: "无党派民主人士",
        value: '12'
      },
      {
        text: "群众",
        value: '13'
      },
      {
        text: "其他",
        value: '14'
      },
    ],
    level: [{
      text: "精通",
      value: 1
    },
      {
        text: "熟练",
        value: 2
      },
      {
        text: "良好",
        value: 3
      },

      {
        text: "其他",
        value: 4
      },
      {
        text: "其他",
        value: 5
      }

    ],

    language: [{
      text: "英语",
      value: "01"
    },
      {
        text: "日语",
        value: "02"
      },
      {
        text: "俄语",
        value: "03"
      },
      {
        text: "法语",
        value: "04"
      },
      {
        text: "德语",
        value: "05"
      },
      {
        text: "意大利语",
        value: "06"
      },
      {
        text: "西班牙语",
        value: "07"
      },
      {
        text: "朝鲜语",
        value: "08"
      },
      {
        text: "蒙古语",
        value: "09"
      },
      {
        text: "葡萄牙语",
        value: "10"
      },
      {
        text: "阿拉伯语",
        value: "11"
      },
      {
        text: "波斯语",
        value: "12"
      },
      {
        text: "菲律宾语言文化",
        value: "13"
      },
      {
        text: "印尼语",
        value: "14"
      },
      {
        text: "印地语",
        value: "15"
      },
      {
        text: "柬埔寨语",
        value: "16"
      },
      {
        text: "老挝语",
        value: "17"
      },
      {
        text: "缅甸语",
        value: "18"
      },
      {
        text: "马来语",
        value: "19"
      },
      {
        text: "僧加罗语",
        value: "20"
      },
      {
        text: "泰国语",
        value: "21"
      },
      {
        text: "乌尔都语",
        value: "22"
      },
      {
        text: "希伯莱语",
        value: "23"
      },
      {
        text: "越南语",
        value: "24"
      },
      {
        text: "豪萨语",
        value: "25"
      },
      {
        text: "斯瓦西里语",
        value: "26"
      },
      {
        text: "阿尔巴尼亚语",
        value: "27"
      },
      {
        text: "保加利亚语",
        value: "28"
      },
      {
        text: "波兰语",
        value: "29"
      },
      {
        text: "罗马尼亚语",
        value: "30"
      },
      {
        text: "瑞典语",
        value: "31"
      },
      {
        text: "塞尔维亚语",
        value: "32"
      },
      {
        text: "土耳其语",
        value: "33"
      },
      {
        text: "希腊语",
        value: "34"
      },
      {
        text: "匈牙利语",
        value: "35"
      },
      {
        text: "汉语",
        value: "98"
      },
      {
        text: "其他外语",
        value: "99"
      }
    ],
    SYQGZDC: [{
      text: "1000以下",
      value: 1
    },
      {
        text: "1000-1999",
        value: 2
      },
      {
        text: "2000-2999",
        value: 3
      },
      {
        text: "3000-3999",
        value: 4
      },
      {
        text: "4000-4999",
        value: 5
      },
      {
        text: "5000及以上",
        value: 6
      },
      {
        text: "其他",
        value: 9
      }
    ],
    stay: [{
      text: "否",
      value: 0
    },
      {
        text: "提供住宿",
        value: 1
      },
      {
        text: "提供工作餐",
        value: 2
      },
      {
        text: "提供住宿与工作餐",
        value: 3
      },
    ],
    fund: [{
      text: "有",
      value: 1
    },
      {
        text: "无",
        value: 0
      },
      {
        text: "其他",
        value: 9
      }
    ],

    jlList: {

      "userId": "",
      "resumeName": "", // 简历名称

      "projectExperience": [],


      "gzxz": "",
      "jobAddress": "",
      "jobAddress1": "",
      "zwlb": "",
      "zwlb1": "",
      "hylb": "",
      "hylb1": "",
      "salary": "",

      "educationalBack": [{
        "schoolTag": "",
        "education": "",
        "studyTime": "",
        "graduationTime": "",
        "majorName": "",
      }],
      "workExperience": [],
      // {
      //   "workUnit":"",
      //   "jobName":"",
      //   "startTime":"",
      //   "endTime":"",
      //   "industry":"",
      //   "industry1":"",
      //   "jobContent":"",
      // }
      "method": "Resume_insertResume",
      "zwpj": "",
      "cid": "",
      "tokenid": "123"
    },
    dy: [{
      text: '中共党员',
      value: '01'
    }, {
      text: '中共预备党员',
      value: '02'
    }, {
      text: '其他党派成员',
      value: '03'
    }, {
      text: '群众',
      value: '13'
    },
      {
        text: '其他',
        value: '99'
      }
    ],
    address: [{
      value: "320104000000",
      text: "秦淮区"
    }, {
      value: "320106000000",
      text: "鼓楼区"
    }, {
      value: "320124000000",
      text: "溧水区"
    }, {
      value: "320115000000",
      text: "江宁区"
    }, {
      value: "320113000000",
      text: "栖霞区"
    }, {
      value: "320116000000",
      text: "六合区"
    }, {
      value: "320125000000",
      text: "高淳区"
    },
      {
        value: "320199000000",
        text: "南京市区"
      },
      {
        value: "320102000000",
        text: "玄武区"
      },
      {
        value: "320111000000",
        text: "浦口区"
      },
      {
        value: "320114000000",
        text: "雨花台"
      },
      {
        value: "320105000000",
        text: "建邺区"
      },
      {
        value: "320126000000",
        text: "新港开发区"
      },
      {
        value: "320127000000",
        text: "化工园开发"
      },
      {
        value: "320128000000",
        text: "高新区"
      }
    ],
    sexList: [{
      value: '1',
      text: '男'
    }, {
      value: '2',
      text: '女'
    }],
    Mingzu: [{
      value: "01",
      text: "汉族"
    },
      {
        value: "02",
        text: "蒙古族"
      },
      {
        value: "45",
        text: "鄂温克族"
      },
      {
        value: "28",
        text: "景颇族"
      },
      {
        value: "29",
        text: "柯尔克孜族"
      },
      {
        value: "30",
        text: "土族"
      },
      {
        value: "31",
        text: "达翰尔族"
      },
      {
        value: "32",
        text: "仫佬族"
      },
      {
        value: "33",
        text: "羌族"
      },
      {
        value: "34",
        text: "布朗族"
      },
      {
        value: "35",
        text: "撒拉族"
      },
      {
        value: "36",
        text: "毛南族"
      },
      {
        value: "37",
        text: "仡佬族"
      },
      {
        value: "38",
        text: "锡伯族"
      },
      {
        value: "39",
        text: "阿昌族"
      },
      {
        value: "03",
        text: "回族"
      },
      {
        value: "46",
        text: "德昂族"
      },
      {
        value: "47",
        text: "保安族"
      },
      {
        value: "48",
        text: "裕固族"
      },
      {
        value: "49",
        text: "京族"
      },
      {
        value: "50",
        text: "塔塔尔族"
      },
      {
        value: "51",
        text: "独龙族"
      },
      {
        value: "52",
        text: "鄂伦春族"
      },
      {
        value: "53",
        text: "赫哲族"
      },
      {
        value: "54",
        text: "门巴族"
      },
      {
        value: "55",
        text: "珞巴族"
      },
      {
        value: "56",
        text: "基诺族"
      },
      {
        value: "99",
        text: "其他"
      },
      {
        value: "40",
        text: "普米族"
      },
      {
        value: "41",
        text: "塔吉克族"
      },
      {
        value: "42",
        text: "怒族"
      },
      {
        value: "43",
        text: "乌孜别克族"
      },
      {
        value: "44",
        text: "俄罗斯族"
      },
      {
        value: "04",
        text: "藏族"
      },
      {
        value: "05",
        text: "维吾尔族"
      },
      {
        value: "06",
        text: "苗族"
      },
      {
        value: "07",
        text: "彝族"
      },
      {
        value: "08",
        text: "壮族"
      },
      {
        value: "09",
        text: "布依族"
      },
      {
        value: "10",
        text: "朝鲜族"
      },
      {
        value: "11",
        text: "满族"
      },
      {
        value: "12",
        text: "侗族"
      },
      {
        value: "13",
        text: "瑶族"
      },
      {
        value: "14",
        text: "白族"
      },
      {
        value: "15",
        text: "土家族"
      },
      {
        value: "16",
        text: "哈尼族"
      },
      {
        value: "17",
        text: "哈萨克族"
      },
      {
        value: "18",
        text: "傣族"
      },
      {
        value: "19",
        text: "黎族"
      },
      {
        value: "20",
        text: "傈傈族"
      },
      {
        value: "21",
        text: "佤族"
      },
      {
        value: "22",
        text: "畲族"
      },
      {
        value: "23",
        text: "高山族"
      },
      {
        value: "24",
        text: "拉祜族"
      },
      {
        value: "25",
        text: "水族"
      },
      {
        value: "26",
        text: "东乡族"
      },
      {
        value: "27",
        text: "纳西族"
      },
    ],
    peopleContent: [ // 人员类别
      {
        value: "1",
        text: '在职人员'
      },
      {
        value: "2",
        text: '待业人员'
      },
      {
        value: "3",
        text: '应届高校毕业生'
      },
      {
        value: "4",
        text: '在校学生'
      },

    ],
    Qx: [ // 区县
      {
        value: "320102010102",
        text: '玄武区大创办'
      },
      {
        value: "320102010103",
        text: '秦淮区大创办'
      },
      {
        value: "320102010104",
        text: '建邺区大创办'
      },
      {
        value: "320102010105",
        text: '鼓楼区大创办'
      },
      {
        value: "320102010106",
        text: '浦口区大创办'
      },
      {
        value: "320102010107",
        text: '六合区大创办'
      },
      {
        value: "320102010108",
        text: '栖霞区大创办'
      },
      {
        value: "320102010109",
        text: '雨花台区大创办'
      },
      {
        value: "320102010110",
        text: '江宁区大创办'
      },
      {
        value: "320102010111",
        text: '溧水区大创办'
      },
      {
        value: "320102010112",
        text: '高淳区大创办'
      },
      {
        value: "320102010114",
        text: '南京经济技术开发区大创办'
      },
      {
        value: "320102010116",
        text: '职培中心'
      },
      {
        value: "320102010117",
        text: '就业管理中心'
      },
      {
        value: "320102010118",
        text: '江北新区大创办'
      },
    ],

    JobCate: [{
      text: '全职',
      value: 1
    }, {
      text: '兼职',
      value: 2
    }, {
      text: '实习',
      value: 3
    }, {
      text: '临时',
      value: 4
    }, {
      text: '小时工',
      value: 5
    }, {
      text: '全职/兼职/实习均可',
      value: 6
    }],
    company: [{
      "value": "1",
      "text": "3000人以上"
    },
      {
        "value": "2",
        "text": "1000--2999人"
      },
      {
        "value": "3",
        "text": "500--999人"
      },
      {
        "value": "4",
        "text": "100--499人"
      },
      {
        "value": "5",
        "text": "10--99人"
      },
      {
        "value": "6",
        "text": "10人以下"
      },
      {
        "value": "9",
        "text": "其他"
      }
    ],
    moneyPicker: [ // 期望薪资
      {
        value: "2",
        text: '1630-1999元'
      },
      {
        value: "3",
        text: '2000-2999元'
      },
      {
        value: "4",
        text: '3000-3999元'
      },
      {
        value: "5",
        text: '4000-4999元'
      },
      {
        value: "6",
        text: '5000-6999元'
      },
      {
        value: "7",
        text: '7000-9999元'
      },
      {
        value: "8",
        text: '1万元以上'
      }
    ],
    sbType: [{
      value: "1",
      text: "申报"
    },
      {
        value: "2",
        text: "资质合格"
      },
      {
        value: "3",
        text: "资质不合格"
      },
      {
        value: "4",
        text: "初审通过"
      },
      {
        value: "5",
        text: "初审未通过"
      },
      {
        value: "6",
        text: "复审通过"
      },
      {
        value: "7",
        text: "复审未通过"
      },
      {
        value: "8",
        text: "获批"
      },
      {
        value: "9",
        text: "未获批"
      },
    ],
    // 所属中心、原档案所在地
    fileLocation: [{
      value: "02",
      text: "南京市江宁区"
    },
      {
        value: "03",
        text: "南京市雨花台区"
      },
      {
        value: "04",
        text: "南京市六合区"
      },
      {
        value: "05",
        text: "南京市鼓楼区"
      },
      {
        value: "06",
        text: "南京市秦淮区"
      },
      {
        value: "07",
        text: "南京市高淳区"
      },
      {
        value: "08",
        text: "南京市溧水区"
      },
      {
        value: "09",
        text: "南京市浦口区"
      },
      {
        value: "10",
        text: "南京市人才中心"
      },
      {
        value: "19",
        text: "南京市栖霞区"
      },
      {
        value: "20",
        text: "南京市市人才库房(二)"
      },
      {
        value: "22",
        text: "南京市玄武区"
      },
      {
        value: "23",
        text: "南京市江北新区"
      },
      {
        value: "24",
        text: "南京市经开区"
      },
      {
        value: "25",
        text: "南京市江北新区"
      },
      {
        value: "26",
        text: "高层人才"
      },
      {
        value: "27",
        text: "南京市建邺区"
      },
      {
        value: "21",
        text: "南京市玄武区就管"
      },
    ]
  },
})
export default store



//////////////////
// WEBPACK FOOTER
// ./static/sotre/index.js
// module id = null
// module chunks = 